import { Component, EventEmitter, Input, Output } from '@angular/core';
export interface ContainerInterface {
  icon?: string;
  title: string;
  description: string;
  button?: string;
}

@Component({
  selector: 'bfd-container-display-message',
  templateUrl: './bfd-container-display-message.component.html',
  styleUrls: ['./bfd-container-display-message.component.scss'],
})
export class ContainerDisplayMessage {

  @Input() content?: ContainerInterface;
  @Output() dispatchEventEmmiter: EventEmitter<void> = new EventEmitter<void>();
  

  public dispatchEvent($event): void {
    this.dispatchEventEmmiter.emit();
  }
}
